import cx from 'classnames';
import { ReactNode } from 'react';

import styles from './TopBar.module.css';

interface TopBarProps {
  className?: string;
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
}

export default function TopBar({
  className,
  leftSlot,
  rightSlot,
}: TopBarProps): JSX.Element {
  return (
    <div className={cx(styles['base'], className)}>
      <div className={styles['left-slot']}>{leftSlot}</div>
      <div className={styles['right-slot']}>{rightSlot}</div>
    </div>
  );
}
